import { render, staticRenderFns } from "./notification-images.vue?vue&type=template&id=0f178eda&scoped=true&"
import script from "./notification-images.vue?vue&type=script&lang=js&"
export * from "./notification-images.vue?vue&type=script&lang=js&"
import style0 from "./notification-images.vue?vue&type=style&index=0&id=0f178eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f178eda",
  null
  
)

export default component.exports